import type { AddressQuery } from '../types/house'
import type { UsageProfile } from '../types/scan'

/** Pre-filled address used across the site so the full scan can be demoed in one click. */
export const DEMO_ADDRESS: AddressQuery = { postcode: '3905 XP', number: '12', addition: '' }

export const demoUsage: UsageProfile = {
  houseType: 'hoekwoning',
  persons: 4,
  hasSolar: true,
  solarPanels: 16,
  heatPump: false,
  evCharger: true,
  airco: false,
  contract: 'dynamisch',
  annualUsage: 6400,
  usageEdited: false,
}

export const demoContact = {
  name: 'Sanne de Vries',
  email: 'sanne.devries@voorbeeld.nl',
  phone: '06 12 34 56 78',
  note: 'Meterkast zit in de garage, naast de achterdeur.',
}

export function isDemoQuery(q: AddressQuery): boolean {
  return (
    q.postcode.replace(/\s/g, '').toUpperCase() === DEMO_ADDRESS.postcode.replace(/\s/g, '') &&
    q.number.trim() === DEMO_ADDRESS.number &&
    !q.addition.trim()
  )
}
